import { get } from "lodash-es";
import axios from "axios";

export default {
  state: () => ({
    empresas: [],
    empresaForUpdate: null,
  }),
  mutations: {
    setEmpresas(state, payload) {
      state.empresas = payload;
    },
    setEmpresaForUpdate(state, payload) {
      state.empresaForUpdate = payload;
    },
  },
  actions: {
    async getEmpresas(context, payload) {
      const params = {};

      if (payload) {
        params.clienteId = payload;
      }
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetEmpresasByClienteId",
          parameters: [{ name: "id_cliente", value: params.clienteId }],
        });

        if (resp.data.ok) {
          const empresas = get(resp, "data.result[0]", []);
          context.commit("setEmpresas", empresas);
        }

        return resp.data;
      } catch (error) {
        console.log("Error caught:", error);
      }
    },
  },
};
